﻿import * as numeral from 'numeral';

export class NumeralConverter {
  constructor() {
    numeral.register('locale', 'nb-NO', {
      delimiters: {
        thousands: ' ',
        decimal: ','
      },
      abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
      },
      ordinal: function (number) {
        return '.';
      },
      currency: {
        symbol: 'NOK'
      }
    });
    numeral.register('locale', 'nb', {
      delimiters: {
        thousands: ' ',
        decimal: ','
      },
      abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
      },
      ordinal: function (number) {
        return '.';
      },
      currency: {
        symbol: 'NOK'
      }
    });
    numeral.register('locale', 'en-US', {
      delimiters: {
        thousands: ' ',
        decimal: '.'
      },
      abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
      },
      ordinal: function (number) {
        return '.';
      },
      currency: {
        symbol: 'USD'
      }
    });
    numeral.register('locale', 'nn-NO', {
      delimiters: {
        thousands: ' ',
        decimal: ','
      },
      abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
      },
      ordinal: function (number) {
        return '.';
      },
      currency: {
        symbol: 'NOK'
      }
    });
    numeral.locale('nb-NO');
  }
  public format(value: number | string, format: string | number): string {
    if (format === undefined || format === null || format === '') {
      return value.toString();
    }

    if (typeof format === 'string') {
      switch (format) {
        case 'oneDec': format = '0,0.0'; break;
        case 'twoDec': format = '0,0.00'; break;
        case 'fourDec': format = '0,0.0000'; break;
        case 'sixDec': format = '0,0.000000'; break;
        case 'tenDec': format = '0,0.0000000000'; break;
        case 'zeroDec': format = '0,0'; break;
      }
    } else {
      format = format !== 0 ? `0,0.${'0'.repeat(format)}` : '0,0';
    }
    return numeral(value).format(format) as string;
  }

  public parse(value: number | string) {
    return numeral(value).value() as number;
  }
}
